import { typewriter } from './_typewriter';

export function profile() {
  const scrollFading = (el, fadeStart = 0, fadeEnd = 50) => {
    console.log(fadeEnd);
    const updateOpacity = () => {
      const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      const opacity = 1 - Math.min(1, (scTop - fadeStart) / (fadeEnd - fadeStart));
      if (scTop < fadeEnd) {
        el.style.opacity = opacity;
      } else {
        el.style.opacity = 0;
      }
    }
    // スクロールイベントに関数をバインド
    document.addEventListener('scroll', updateOpacity);

    // 初期状態の設定
    updateOpacity();
  }

  const scrollWidth = (el) => {
    const fadeStart = 0; // 幅が変化し始めるスクロール位置
    const fadeEnd = 200; // 幅が0%になるスクロール位置
    const updateWidth = () => {
      const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      const width = Math.max(0, 100 - 100 * ((scTop - fadeStart) / (fadeEnd - fadeStart))); // 幅を計算
      if (scTop < fadeEnd) {
        el.style.width = `${width}%`; // 幅を更新
      } else {
        el.style.width = '0%'; // 幅を0%に設定
      }
    };
    // スクロールイベントに関数をバインド
    document.addEventListener('scroll', updateWidth);

    // 初期状態の設定
    updateWidth();
  }

  const container = document.querySelector('.js-profile-container');
  const identityJa = document.querySelector('.js-identity-text-ja');
  const line = document.querySelector('.js-profile-line');

  if(container) {
    document.body.classList.add('is-init-profile')
    if(identityJa) {
      let fadeStart = 0; // 透明度が変化し始めるスクロール位置
      let fadeEnd = 50; // 透明度が0になるスクロール位置
      if(identityJa.dataset.fadeStart) fadeStart = identityJa.dataset.fadeStart;
      if(identityJa.dataset.fadeEnd) fadeEnd = identityJa.dataset.fadeEnd;
      scrollFading(identityJa, fadeStart, fadeEnd);
    }
    if(line) scrollWidth(line);
    setTimeout(() => {
      if(identityJa && identityJa.classList.contains('is-typewriter')) typewriter(identityJa);
      if(line) line.classList.add('is-animation-end')
    }, 800)
  }
}